<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
  <h1 *ngIf="title" [style.color]="color">
    {{ title }}
  </h1>

  <div class="rule" *ngFor="let rule of passwordPolicy" [style.color]="color">
    <div class="rule-dot">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <circle
          cx="10"
          cy="10"
          r="9.5"
          [attr.fill]="color"
          [attr.stroke]="color"
          [attr.fill-opacity]="rule.validated ? 1 : 0"
        />
      </svg>
    </div>
    <div class="rule-message">{{ rule.message }}</div>
  </div>
  <div class="rule" [style.color]="color">
    <div class="rule-dot">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
      >
        <circle
          cx="10"
          cy="10"
          r="9.5"
          [attr.fill]="color"
          [attr.stroke]="color"
          [attr.fill-opacity]="passwordsIdentical.validated ? 1 : 0"
        />
      </svg>
    </div>
    <div class="rule-message">{{ passwordsIdentical.message | translate }}</div>
  </div>

  <bepatient-onboarding-subtitle
    *ngIf="subtitle"
    [title]="subtitle"
    [color]="color"
  >
  </bepatient-onboarding-subtitle>

  <bepatient-onboarding-input-text
    *ngIf="requireCurrentPassword"
    type="password"
    [color]="color"
    [placeholder]="currentPasswordLabel"
    [bpFormGroup]="passwordForm"
    (ionChange)="hasError = false"
    [bpFormControlName]="passwordForm.get('currentPassword')"
    (keyup)="handlekeyUp($event)"
  >
  </bepatient-onboarding-input-text>

  <div *ngIf="hasError && passwordForm.dirty" class="error_message">
    {{ errorLabel }}
  </div>

  <bepatient-onboarding-input-text
    type="password"
    [color]="color"
    [placeholder]="passwordLabel"
    [bpFormGroup]="passwordForm"
    [bpFormControlName]="passwordForm.get('password')"
    (keyup)="handlekeyUp($event)"
  >
  </bepatient-onboarding-input-text>

  <bepatient-onboarding-input-text
    type="password"
    [color]="color"
    [placeholder]="confirmationLabel"
    [bpFormGroup]="passwordForm"
    [bpFormControlName]="passwordForm.get('confirmation')"
    (keyup)="handlekeyUp($event)"
  >
  </bepatient-onboarding-input-text>

  <input type="hidden" formControlName="passwordFormValid" />
  <div id="strength-bar" *ngIf="showPasswordStrength" class="password-strength">
    <p>
      <span [ngStyle]="{ color: color }"
        >{{ passwordStrengthLabel | translate }}:
      </span>
      <strong [ngStyle]="{ color: passwordStrength.color }">{{
        passwordStrength.label | translate
      }}</strong>
    </p>
    <ion-progress-bar
      [color]="progressBarDefaultBackground"
      [value]="passwordStrength.value"
    ></ion-progress-bar>
  </div>
  <div class="password_info">
    <p [ngStyle]="{ color: color }">
      <span>{{ 'USER_PASSWORD.PASSWORD_INFO.NOTE' | translate }}:</span>
      {{ 'USER_PASSWORD.PASSWORD_INFO.DESCRIPTION' | translate }}
    </p>
  </div>
</form>

<bepatient-onboarding-button
  [color]="color"
  [disabled]="!formIsValid"
  (buttonClick)="onSubmit()"
  [isInstanceColor]="true"
>
  {{ buttonLabel }}
</bepatient-onboarding-button>
